import React from "react"
import PropTypes from "prop-types"

import "./styles/Terms.css"

const DealSuccessTerms = ({termsAndConditions}) => {
  if (!termsAndConditions) {
    return null
  }

  return <div className="dealSuccessTerms">{termsAndConditions}</div>
}

DealSuccessTerms.defaultProps = {
  termsAndConditions: null
}

DealSuccessTerms.propTypes = {
  termsAndConditions: PropTypes.string
}

export default DealSuccessTerms
